import api from 'utils/api'
import { API_ROOT } from '../constants'

export const createSubscription = async ({
  email,
  name,
  paymentMethodId,
  priceId,
  studentData,
  paymentGateway,
  source,
  upgradeReason,
  productId,
  teamMemberPriceId,
  couponId,
  verifyAccountExistence,
  setupIntentId,
  businessDetails,
  headers
}) => {
  const reqData = {
    email,
    name,
    paymentMethodId,
    priceId,
    teamMemberPriceId,
    studentData,
    paymentGateway,
    source,
    upgradeReason,
    productId,
    couponId,
    verifyAccountExistence,
    setupIntentId,
    businessDetails
  }
  // Use generic endpoint for all payment gateways (Paddle Classic removed)
  const route = 'v3/subscription/create'
  return api.post(`${API_ROOT}/${route}`, reqData, headers).then((result) => {
    if (result.error) {
      throw result
    }
    return result
  })
}

export const createFreeTrialSubscription = ({
  email,
  name,
  paymentMethodId,
  priceId,
  allowB2C,
  businessDetails,
  headers
}) => {
  const reqData = {
    email,
    name,
    paymentMethodId,
    priceId,
    allowB2C,
    businessDetails
  }

  return api.post(`${API_ROOT}/v3/subscription/trial/start`, reqData, headers).then((result) => {
    if (result.error) {
      throw result
    }
    return result
  })
}

export const cancelFreeTrialSubscription = ({ email, headers }) => {
  const reqData = {
    email
  }

  return api.post(`${API_ROOT}/v3/subscription/trial/cancel`, reqData, headers).then((result) => {
    if (result.error) {
      throw result
    }
    return result
  })
}

export const createPaymentMethod = (stripe, cardElement, billing_details) => {
  // Make sure we don't include vatId in billing_details as Stripe doesn't accept it
  const validBillingDetails = { ...billing_details }

  delete validBillingDetails.vatId

  return stripe.createPaymentMethod({
    type: 'card',
    card: cardElement,
    billing_details: validBillingDetails
  })
}

export const createOneTimePayment = (stripe, clientSecret, card) =>
  stripe.confirmCardPayment(clientSecret, {
    payment_method: {
      card: card
    },
    setup_future_usage: 'off_session'
  })
